module.exports = __webpack_public_path__ + "img/bot-welcome.f702015a.svg";